import { useGetStateQuery } from "../../../redux/services/stateService/state.Services";
import { useGetCityQuery } from "../../../redux/services/cityService/city.Services";
import { useGetAmenitiesQuery } from "../../../redux/services/AmenitiesService/amienities.Services";
import { useGetLocationQuery } from "../../../redux/services/locationService/location.Services";
import { useGetCategoriesQuery } from "../../../redux/services/categoriesService/categories.Services";
import { useGetSubCategoriesQuery } from "../../../redux/services/subCategoriesService/subCategories.Services";

export const useCreateProductData = (formData) => {
  const { data: c } = useGetCategoriesQuery();
  const { data: sc } = useGetSubCategoriesQuery();
  const { data: s } = useGetStateQuery();
  const { data: ci } = useGetCityQuery();
  const { data: a } = useGetAmenitiesQuery();
  const { data: l } = useGetLocationQuery();
  const cities = ci?.data || [];

  const filteredCities = cities.filter(
    (city) => Number(city.state_id) === Number(formData.state_id)
  );

  return {
    categories: c?.data || [],
    subCategories: sc?.data || [],
    states: s?.data || [],
    cities,
    filteredCities,
    amenities: a?.data || [],
    locations: l?.data || [],
  };
};
